export const promisedGetBase64 = (file: File) => {
  const reader = new FileReader()
  reader.readAsDataURL(file)
  return new Promise<any>((resolve, reject) => {
    reader.onload = function () {
      resolve(reader.result)
    }
    reader.onerror = function (error) {
      reject(error)
    }
  })
}
